import { useIsFocused, useNavigation } from '@react-navigation/native';
import { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { useEffect } from 'react';

export default function useSetScreenOptions(options: NativeStackNavigationOptions) {
  const isFocused = useIsFocused();
  const navigation = useNavigation();

  useEffect(() => {
    if (isFocused) navigation.setOptions(options);
  }, [options, isFocused, navigation]);

  return { isFocused };
}
